import React, { useEffect, Suspense, useContext, useState } from "react";
import { Route, Switch, useLocation, Redirect, useHistory } from "react-router-dom";

//Funciones
import {
  setTSConc,
  setStatsSession,
  setStatsLibro,
} from "./js/functions/estadisticas.js";
import ReactGA from "react-ga";
import { Workbox, messageSW } from "workbox-window";
import useObtenerSubsecciones from "./js/translations/useObtenerSubsecciones";

//Store
import { store } from "./components/Store";

//Componentes
import Blog from "./blog";
import BlogEntrada from "./blog/BlogEntrada";
import BlogRedirection from "./blog/BlogRedirection";
import Busqueda from "./busqueda/busqueda";
import Club from "./club-makemake/club.js";
import Demo from "./demo";
import Descargados from "./offline/descargados";
import Error404 from "./404";
import FichaColeccion from "./coleccion";
import FichaEditorial from "./editorial";
import Ficha from "./fichas/Ficha.js";
import Header from "./components/header/index";
import InformacionInstitucional from "./informacion";
import Ayuda from "./ayuda-soporte/index.js";
import Login from "./login/login";
import MiPanel from "./mi-panel";
import PoliticaPrivacidad from "./politica-de-privacidad";
import PoliticaSoporte from "./PoliticaSoporte";
import QueEs from "./que-es/index";
import ScrollToTop from "./js/utilities/ScrollToTop";
// import SinConexion from './offline/sin-conexion';
import SuscripcionBoletin from "./suscripcion-boletin";
import TerminosCondiciones from "./terminos-y-condiciones";
import Visor from "./visor";
import Institucional from "./institucional/index.js";

import { ModoPWAContext } from "./contexts/ModoPwaContext";
import { useDetectAdBlock } from "adblock-detect-react";
import { ModalAdBlockDetector } from "./components/modals/ModalAdBlockDetector.js";
import MicroModal from "micromodal";
import { useConexion } from "./hooks/useConexion.js";
import { useModoAplicacion } from "./hooks/useModoAplicacion.js";
import { CancelRequestController } from "./util/cancel-request-controller.js";
import { PWAconsole } from "./util/service-worker-messges.js";
import AssetsRedirect from "./redirect.js";
import Codigo from "./codigo/index.js";
import { UpdateButton } from "./components/UpdateButton.js";
import Footer from "./components/Footer.js";
import { useQueryParams } from "./hooks/useQueryParams.js";

import { DemoPopUp } from "./demo-popup/demo-popup.js";
import { useChat } from "./hooks/useChat.js";
import { TiendaMakeMake } from "./tienda-makemake/index.js";
import { Curadurias } from "./curadurias/index.js";
import { AdvancedSearch } from "./components/advanced-search/index.js";
import { Home } from "./home/index.js";
import { ExternalAuth } from "./components/external-auth/index.js";

//Componentes
/* const Home = lazy(() => import("./home"));
const Login = lazy(() => import("./login"));
const SuscripcionBoletin = lazy(() => import("./suscripcion-boletin"));
const Informacion = lazy(() => import("./informacion"));
const FichaLibro = lazy(() => import("./fichas"));
const FichaColeccion = lazy(() => import("./coleccion"));
const FichaEditorial = lazy(() => import("./editorial"));
const Busqueda = lazy(() => import("./busqueda/busqueda"));
const TerminosCondiciones = lazy(() => import("./terminos-y-condiciones"));
const PoliticaPrivacidad = lazy(() => import("./politica-de-privacidad"));
const Error404 = lazy(() => import("./404"));
const Descargados = lazy(() => import("./offline/descargados"));
const SinConexion = lazy(() => import("./offline/sin-conexion"));
const Visor = lazy(() => import("./visor"));
const InstruccionesDescarga = lazy(() => import("./home/InstruccionesDescarga"));
const Blog = lazy(() => import("./blog"));
const BlogEntrada = lazy(() => import("./blog/BlogEntrada"));
const MiPanel = lazy(() => import("./mi-panel")); */

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    let page = `${location.pathname}${location.search}`;
    ReactGA.set({ page: page });
    ReactGA.pageview(page);
  }, [location]);
}
//Componente principal
/**
 * El componente `Application` es el punto de entrada principal de la aplicación. Es responsable de coordinar
 * y gestionar todos los demás componentes y módulos de la aplicación.
 * - Internamente se encarga de realizar lógica relacionada al registro, activación, actualización y gestión del service worker
 * - Contiene el enrutamiento principal de toda la aplicación, por lo tanto se encarga de renderizar el componente correspondiente con base a la ruta actual.
 * - Gestiona eventos y acciones globales de la aplicación.
 * - Gestiona la autenticación y el control de acceso.
 */
const Application = () => {
  const { isReady, textosSubSecciones: textoHome } =
    useObtenerSubsecciones("home");

  const globalState = useContext(store);
  const pwaContext = useContext(ModoPWAContext);
  const { dispatch, state } = globalState;
  const { progresoDescarga } = state;
  const location = useLocation();
  const adBlockDetector = useDetectAdBlock();
  const conexion = useConexion();
  const modoAplicacion = useModoAplicacion();
  const params = useQueryParams();
  const history = useHistory();
  const authenticatedUser = globalState?.state?.sesionActiva === 'SI';

  // const [mostrarActualizar, setMostrarActualizar] = useState(false);
  const [registration, setRegistration] = useState(null);
  const [wbState, setWbState] = useState(null);
  const chat = useChat();

  useEffect(() => {
    if(window.location.origin.split('').reverse().join('') === 'oc.moc.ekamekam//:sptth' || window.location.origin === 'https://nf.app.makemake.reallabs.com.co' || window.location.origin.includes("localhost") ){
      // console.log('PROXY TEST: Es makemake');
    }else{
      if(window.location.origin === "https://s443-makemake-com-co.cerlalc.lsproxy.net"){
        const redirect = window.location.pathname;
        window.location.replace(process.env.REACT_APP_API + '/assets/verificarSesion?proxyPass&redirect=' + redirect);
      }
    }
  }, [location])

  usePageViews();

  const refreshServiceWorker = async () => {
    await caches
      .keys()
      .then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      })
      .then(() => {
        PWAconsole.info("Cache was cleared!");
      })
      .catch((err) => PWAconsole.log(err));

    await navigator.serviceWorker.getRegistration().then(x => {
      x.unregister();
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister()
        })
      })
      console.log('All services workers were removed.')
    })
      .catch((err) => PWAconsole.log(err));
    return;
  };

  const redirectHandler = () => {
    const redirectQuery = decodeURIComponent(params.get('redirect'));
    if (location.pathname === '/' && params.has('redirect')) {
      history.push(redirectQuery);
    }
  }

  useEffect(() => {
    redirectHandler();
  }, [location, params])


  useEffect(() => {
    // mostrar el modal de adblock activado
    //OCULTO TEMPORALMENTE - AL
    // let timer = setTimeout(() => {
    //   if (
    //     adBlockDetector === true &&
    //     modoAplicacion === false &&
    //     conexion.online === true
    //   ) {
    //     try {
    //       MicroModal.show("modal-adblock-detector", {
    //         awaitCloseAnimation: true,
    //       });
    //     } catch (error) {
    //       PWAconsole.log(error);
    //     }
    //   }
    // }, 2000);
    // return () => {
    //   clearTimeout(timer);
    // };
  }, [adBlockDetector, conexion.online, modoAplicacion]);

  useEffect(() => {
    //AE: ESTO DEBERÍA ESTAR EN LA FICHA DE LIBRO
    //NZ: se agrega aqui para permitir desscargas mientras se sigue navegando en makemake
    if (progresoDescarga === "100%") {
      //Retrasa la desparicion de la barra de progreso
      setTimeout(() => {
        dispatch({
          type: "CHANGE_VALUE",
          property: "descargando",
          value: false,
        });
        dispatch({
          type: "CHANGE_VALUE",
          property: "tituloDescargando",
          value: "",
        });
        dispatch({
          type: "CHANGE_VALUE",
          property: "progresoDescarga",
          value: "0%",
        });
      }, 3000);
    }
  }, [progresoDescarga]);

  useEffect(() => {
    const timerTs = setInterval(setTSConc, 50000);
    const timerStatsSession = setInterval(setStatsSession, 9000);

    dispatch({
      type: "CHANGE_VALUE",
      property: "abortCtrl",
      value: new CancelRequestController(),
    });
    if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
      const wb = new Workbox("/sw.js");
      let registrationVar;

      navigator.serviceWorker.ready.then((registration) => {
        PWAconsole.info(`A service worker is active and ready to use`);
        pwaContext.dispatch({
          type: "CHANGE_VALUE",
          payload: {
            property: "serviceWorkerActivado",
            value: true,
          },
        });
        pwaContext.dispatch({
          type: "CHANGE_VALUE",
          payload: {
            property: "serviceWorkerInstalado",
            value: true,
          },
        });
      });

      wb.addEventListener("activated", (event) => {
        pwaContext.dispatch({
          type: "CHANGE_VALUE",
          payload: {
            property: "serviceWorkerActivado",
            value: true,
          },
        });
        // `event.isUpdate` will be true if another version of the service
        // worker was controlling the page when this version was registered.

        if (event.isUpdate) {
          PWAconsole.info("new update");
        } else {
          // If your service worker is configured to precache assets, those
          // assets should all be available now.
          PWAconsole.info("Service worker activated for the first time!");
        }
      });

      wb.messageSW({ type: "GET_VERSION" }).then((swVersion) => {
        PWAconsole.info("Service Worker version:", swVersion);
      });

      wb.addEventListener("waiting", (event) => {
        PWAconsole.info(`A new update is ready to be installed`);
        // setMostrarActualizar(true);
        setRegistration(registrationVar);
        setWbState(wb);
        pwaContext.dispatch({
          type: "CHANGE_VALUE",
          payload: {
            property: "actualizacionInstalable",
            value: true,
          },
        });
      });
      wb.addEventListener("externalwaiting", (event) => {
        // setMostrarActualizar(true);
        setRegistration(registrationVar);
        setWbState(wb);
        pwaContext.dispatch({
          type: "CHANGE_VALUE",
          payload: {
            property: "actualizacionInstalable",
            value: true,
          },
        });
      });

      // if(pwaContext.clienteHabilitado===true && Plataforma.contieneAlmenosUnOS("android;ios") === false){
      wb.register().then((r) => {
        setRegistration(r);
        registrationVar = r;
      });
      setWbState(wb);
      // }else{
      //   if(navigator.serviceWorker){
      //     navigator.serviceWorker.getRegistrations().then(registrations=>{
      //       registrations.forEach(registration=>{
      //         registration.unregister()
      //       })
      //     })
      //   }

      // }
    }

    return () => {
      clearInterval(timerStatsSession);
      clearInterval(timerTs);
    };

    // }, [pwaContext?.clienteHabilitado]);
  }, []);

  const skipWaiting = () => {
    // Send a message to the waiting service worker,
    // instructing it to activate.
    // Note: for this to work, you have to add a message
    // listener in your service worker. See below.
    if (registration && registration.waiting) {
      refreshServiceWorker().then(res => {
        messageSW(registration.waiting, { type: "SKIP_WAITING" });
        PWAconsole.log(`Skipping`);
        window.location.reload();
      })
        .catch(error => PWAconsole.error(error))
    }
  };

  useEffect(() => {
    try {
      dispatch({
        type: "CHANGE_VALUE",
        property: "abortSignal",
        value: state.abortCtrl.signal,
      });
    } catch (error) {
      console.log(error);
    }
  }, [dispatch, state.abortCtrl]);

  useEffect(() => {
    if(location.pathname.includes('/visor')){
      chat.setVisible(false);
      console.log('chat oculto /visor');
    }else{
      if(authenticatedUser ===false){
        chat.setVisible(true);
        console.log('chat visible, el usuario no está autenticado y no está en la ruta /visor');
      }else{
        console.log('chat oculto, el usuario está autenticado y no está en la ruta /visor');
        chat.setVisible(false);
      }
    }
  }, [location.pathname, authenticatedUser])

  const skipLink = (event) => {
    event.preventDefault();
    const container = document.querySelector("#main");
    if (container) {
      container.tabIndex = -1;
      container.focus();
      setTimeout(() => container.removeAttribute("tabindex"), 1000);
    }
  }

  return (
    <>
      {/* OCULTO TEMPORALMENTE - AL */}
      {/* <ModalAdBlockDetector idModal={"modal-adblock-detector"} /> */}
      {
        location.pathname.startsWith('/external-auth') ?
          <Switch>
            <Route path="/external-auth" component={ExternalAuth} />
          </Switch>
          :
          <>
            <ScrollToTop>
              <Suspense
                fallback={
                  <div className="row mx-0 relative" style={{ minHeight: "100vh" }}>
                    <div className={`statistics-preloader`} />
                  </div>
                }
              >

                {isReady &&
                  <button onClick={(e) => skipLink(e)} className='skip-link w-100'>{textoHome?.skip?.texto || 'Saltar al contenido'}</button>
                }
                <Header />
                <main role={"main"} id="main" tabIndex={0} className="focusable-secondary" style={{ minHeight: "100vh" }}>
                  <AdvancedSearch />
                  <Switch>
                    <Route exact path="/" component={MainRoutes} />
                    <Route exact path="/:page" component={MainRoutes} />
                    <Route exact path="/:page/:section" component={MainRoutes} />
                    <Route
                      exact
                      path="/:page/:section/:subsection"
                      component={MainRoutes}
                    />
                    <Route
                      exact
                      path="/:page/:section/:subsection/:param"
                      component={MainRoutes}
                    />
                  </Switch>
                </main>
                {
                  !location.pathname.includes('visor') &&
                  <Footer />
                }
              </Suspense>
              {
                !location.pathname.includes('visor') && globalState?.state?.username === 'Demo_Clever' &&
                <DemoPopUp />
              }

              {/* Botón de actualización */}
              <UpdateButton onClickButton={() => skipWaiting()} />

            </ScrollToTop>
          </>
      }
    </>
  );
};

/**
 * Contiene todas las rutas principales de la aplicación, es llamado dentro de el componente principal `Application`
 * @returns JSX.Element
 */
const MainRoutes = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { isHeaderShow } = state;
  const pwaState = useContext(ModoPWAContext);
  return (
    <>
      {isHeaderShow && (
        <Switch>
          <Route exact path="/home">
            <Redirect to="/" />
          </Route>
          <Route exact path="/" component={Home} />
          <Route exact path="/login" component={Login} />

          <Route exact path="/busqueda" component={Busqueda} />

          <Route exact path="/que-es" component={QueEs} />
          <Route exact path="/que-es-bibliotecas" component={QueEs} />
          <Route exact path="/que-es-colegios" component={QueEs} />

          <Route exact path="/club-makemake" component={Club} />
          <Redirect exact from="/club" to={'/club-makemake'} />

          <Route exact path='/codigo' component={Codigo} />
          <Route exact path='/codigo/:section' component={Codigo} />

          {
            (state.sesionActiva !== "SI" ||
              (state.sesionActiva === "SI" && state.cantidadLibros > 40)) &&
            <Route path='/curadurias' component={Curadurias} />
          }

          <Route exact path="/blog" component={Blog} />
          <Route exact path="/blog/:id" component={BlogEntrada} />
          <Route exact path="/blog/:id/:title" component={BlogEntrada} />
          <Route
            exact
            path="/blog/blogDB/:date/:title"
            component={BlogRedirection}
          />

          <Route path="/tienda" component={TiendaMakeMake} />
          <Redirect exact from="/quiero-makemake/" to={'/tienda'} />
          <Redirect exact from="/compra/*" to={'/tienda'} />

          <Route exact path="/boletin" component={SuscripcionBoletin} />
          <Route
            exact
            path="/boletin/:section"
            component={SuscripcionBoletin}
          />

          <Route exact path="/demo" component={Demo} />
          <Route exact path="/demo/:section" component={Demo} />

          <Route exact path="/informacion/" component={InformacionInstitucional} />
          <Route exact path="/informacion/:section" component={InformacionInstitucional} />

          <Route
            exact
            path="/coleccion/:nombreColeccion/"
            component={FichaColeccion}
          />
          <Route
            exact
            path="/editorial/:nombreEditorial/"
            component={FichaEditorial}
          />

          <Route
            exact
            path="/fichas/:idLibro/:nombreLibro"
            component={Ficha}
          />

          <Route exact path="/mi-panel/" component={MiPanel} />
          <Route exact path="/mi-panel/:section/" component={MiPanel} />
          <Route
            exact
            path="/mi-panel/:section/:subsection"
            component={MiPanel}
          />
          <Route
            exact
            path="/mi-panel/:section/:subsection/:param"
            component={MiPanel}
          />

          <Route
            exact
            path="/politica-de-privacidad"
            component={PoliticaPrivacidad}
          />
          <Route
            exact
            path="/politica-de-soporte"
            component={PoliticaSoporte}
          />
          <Route
            exact
            path="/terminos-y-condiciones"
            component={TerminosCondiciones}
          />

          {state?.cantidadLibros > 40 &&
            pwaState.compatible &&
            pwaState.clienteHabilitado && (
              <Route exact path="/descargados" component={Descargados} />
            )}

          {/* <Route exact path='/sin-conexion' component={SinConexion} /> */}
          <Route exact path="/ayuda" component={Ayuda} />
          <Route exact path="/visor/:idLibro" component={Visor} />

          {/* <Route exact path="/assets/saml/endpoints/">
            <AssetsRedirect />
          </Route>

          <Route exact path="/assetsPlanLector/saml/endpoints/">
            <AssetsRedirect />
          </Route> */}

          <Route exact path='/institucional/:section/' component={Institucional} />
          <Route path='/external-auth' component={ExternalAuth}/>

          <Route component={Error404} />
        </Switch>
      )}
    </>
  );
};

export default Application;
